import * as React from "react";
const SvgFiRrTabFolder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m19.951 3.096-.36-.729A2 2 0 0 0 17.694.999h-1.782a.675.675 0 0 0-.605.975l.507 1.025H13.75l-.313-.632A2 2 0 0 0 11.54.999H9.765a.675.675 0 0 0-.605.975l.507 1.025H7.62l-.724-1.447a1 1 0 0 0-.895-.553h-2A4.006 4.006 0 0 0 0 5v13c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V8a5.005 5.005 0 0 0-4.049-4.904M2 5c0-1.103.897-2 2-2h1.382l.724 1.447A1 1 0 0 0 7.001 5h12c1.302 0 2.402.839 2.816 2H2zm20 13c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V9h20z"
    />
  </svg>
);
export default SvgFiRrTabFolder;
